import { css, etiColors, mediaQueries } from '@eti/styles';
import { useHeightContext, useTranslation } from '@eti/providers';
import { Heading, Inline, LinkButton, Text, vars } from '@etg/wings';
import { SEATING_PREFERENCE_OPTIONS } from '../../utils/constants';
import { getSegment } from '../../utils/segments';
import FromToLabel from '../../components/FromToLabel';
import SeatMapTravelers from '../../components/SeatMapTravelers';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const wrapperStyles = headerHeightContext => css`
  align-items: flex-start;
  background-color: #fff;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  position: sticky;
  top: ${headerHeightContext > 0 ? `${headerHeightContext}px` : '0'};
  transition: top 0.2s ease-in-out;
  z-index: 6;
`;
const contentStyles = css`
  padding: 10px 14px;
  text-align: start;
  width: 100%;

  @media ${mediaQueries.medium.up} {
    padding: 20px 15px;
  }

  @media ${mediaQueries.large.up} {
    padding: 20px 30px;
  }
`;
const selectionWrapperStyles = css`
  background-color: ${etiColors.white};
  border-top: 1px solid ${vars.colors.divider};
  position: relative;
`;
const InlineStyles = css`
  display: flex;
  justify-content: space-between;
`;
const SeatMapHeader = _ref => {
  let {
    active,
    currentSegmentData,
    currentSegmentIndex,
    from,
    isShowingSkipLinkButton,
    isSummaryShowing,
    onSkip,
    onChangeTraveler,
    onNextTravelerClick,
    onPreviousTravelerClick,
    onRemoveSeat,
    segments,
    selectedSeats,
    to,
    totalSegmentsCount,
    travelers
  } = _ref;
  const {
    t
  } = useTranslation();
  const skipLabel = t('Seating.Skip.LinkButton.Text');
  const summaryHeaderText = t('Seating.Summary.Header.Text');
  const {
    headerHeightContext
  } = useHeightContext();
  const [activeSegment] = active;
  const segmentText = currentSegmentData && currentSegmentIndex ? t('Seating.Segments.Details.Description', currentSegmentIndex, totalSegmentsCount, currentSegmentData.from.iata, currentSegmentData.to.iata) : '';
  const currentSegment = getSegment(segments, activeSegment);
  const isSeatingPreferenceAvailable = currentSegment && currentSegment.__typename && (currentSegment.__typename === SEATING_PREFERENCE_OPTIONS.SELL_SEATING_PREFERENCE || currentSegment.__typename === SEATING_PREFERENCE_OPTIONS.SELL_SEATING_BESIDE);
  return /*#__PURE__*/_jsxs("div", {
    className: wrapperStyles(headerHeightContext),
    "data-testid": "seatMap-header",
    children: [/*#__PURE__*/_jsx("div", {
      className: contentStyles,
      children: isSummaryShowing ? /*#__PURE__*/_jsx(Heading, {
        "data-testid": "seatMap-summary-header-text",
        level: 3,
        children: summaryHeaderText
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Heading, {
          "data-testid": "seatMap-originAndDestinations-text",
          level: 3,
          children: /*#__PURE__*/_jsx(FromToLabel, {
            from: from,
            to: to
          })
        }), /*#__PURE__*/_jsxs(Inline, {
          alignY: "center",
          className: InlineStyles,
          noWrap: true,
          children: [/*#__PURE__*/_jsx(Text, {
            "data-testid": "seatMap-segments-text",
            children: segmentText
          }), isShowingSkipLinkButton && /*#__PURE__*/_jsx(LinkButton, {
            "data-testid": "seatMap-skip-linkButton",
            onClick: onSkip,
            children: skipLabel
          })]
        })]
      })
    }), !isSeatingPreferenceAvailable && (currentSegment === null || currentSegment === void 0 ? void 0 : currentSegment.isAvailable) && !isSummaryShowing && /*#__PURE__*/_jsx("div", {
      className: selectionWrapperStyles,
      children: /*#__PURE__*/_jsx(SeatMapTravelers
      // @ts-ignore - WEBTECH-1361
      , {
        active: active,
        onChange: onChangeTraveler,
        onNextTravelerClick: onNextTravelerClick,
        onPreviousTravelerClick: onPreviousTravelerClick,
        onRemoveSeat: onRemoveSeat,
        selectedSeats: selectedSeats
        // @ts-ignore - WEBTECH-1361
        ,
        travelers: travelers
      })
    })]
  });
};
export default SeatMapHeader;
//# sourceMappingURL=SeatMapHeader.js.map